import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { CorrectiveActionsGrid, ServiceThreadSpinner } from '.';
import { api, constants, helpers } from '../utils';

export default function SalesDashboardOpenCars(props) {
  const [data, setData] = useState();
  const [loaded, setLoaded] = useState(false);
  const [salespersonId, setSalespersonId] = useState(props.salespersonId);
  const [sortDirection, setSortDirection] = useState("desc");
  const [sortField, setSortField] = useState("createdDate");

  useEffect(() => {
    if (props.salespersonId !== salespersonId) {
      setSalespersonId(props.salespersonId)
      setLoaded(false);
    }
    if (!loaded) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, props.salespersonId])

  function createPayload() {
    return {
      SortField: sortField,
      SortDirection: sortDirection,
      ActionType: constants.CORRECTIVE_ACTION_TYPES.CorrectiveAction,
      ActionStatus: constants.CORRECTIVE_ACTION_STATUSES.Open,
      CustomerId: '',
      VendorNumber: '',
      ItemNumber: '',
      SalespersonId: props.salespersonId,
      IncludeInternal: false,
      ProblemType: 0,    // ???
      PageNumber: 1,
      PageSize: 100000,
      calledFromSalesDashboard: true
    }
  }

  function exportXlsx() {
    const payload = createPayload();
    api
      .postGetBlob("Customer/ExportCorrectiveActionsXLSX", payload)
      .then(r => {
        if (r.data.success === false) {
          if (_.isString(r?.data?.message)) {
            toast.error(r?.data?.message);
          }
          return;
        }
        if (r.data) {
          const XLSX_FILENAME = payload.SalespersonId ? `${payload.SalespersonId}_OpenCars.xlsx` : `OpenCars.xlsx`;
          helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
        } else {
          toast.error(r.message || "Error downloading report");
        }
      })
      .catch(api.catchHandler);
  }

  function loadData() {
    api
      .post('Quality/GetPaginatedCorrectiveActions', createPayload())
      .then(response => {
        if (response.data.success) {
          setData(response.data.correctiveActions);
        }
        setLoaded(true)
      })
      .catch(api.catchHandler);
  }

  function onPageChange() {
    // page
    // setPage(page);
    setLoaded(false);
  }

  function onSortChange(field, direction) {
    if (field !== sortField) {
      setSortField(field);
      setSortDirection("asc")
    } else {
      setSortDirection(direction);
    }
    onPageChange(1);
  }

  return (
    <React.Fragment>
      <div>
        <span className="h2 me-2">Open Corrective Actions</span>
      </div>
      <hr />
      <ServiceThreadSpinner on={!loaded}>
        {data && data.items && data.items.length > 0
          ? <CorrectiveActionsGrid
            data={data.items}
            sortCallback={onSortChange}
            sortField={sortField}
            sortDirection={sortDirection}
            exportXlsxCallback={exportXlsx}
            calledFromSalesDashboard={true}
          />
          : <span className="h5" style={{ color: "red" }}>No Open Corrective Actions found</span>
        }
      </ServiceThreadSpinner>
    </React.Fragment>
  );
};
